import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PrivateRoute = ({ isAuthenticated, loginPath, dashboardPath, children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is authenticated
    if (!isAuthenticated) {
      // Redirect to the login page
      navigate(loginPath);
    }
    else{
      console.log('go to dashboard');

      navigate(dashboardPath);
    }
  }, [isAuthenticated, loginPath, navigate]);

  return isAuthenticated ? children : null;
};

export default PrivateRoute;